import { faBriefcase, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledActions,
  StyledContainer,
  StyledHeader,
  StyledSteps,
  StyledStepsItem,
  StyledStepsTitle
} from './BringYourOwnTeamHow.styled';

const BringYourOwnTeamHow: React.FC = () => {
  const { t } = useI18n('bring-your-own-team');

  const steps = [
    t('how.steps.step1'),
    t('how.steps.step2'),
    t('how.steps.step3'),
    t('how.steps.step4'),
    t('how.steps.step5')
  ];
  return (
    <StyledContainer id="teams">
      <StyledHeader>
        <Heading3 editorial>{t('how.title')}</Heading3>
        <p>{t('how.desc')}</p>
      </StyledHeader>
      <StyledSteps>
        {steps.map((s, i) => {
          return (
            <StyledStepsItem key={i}>
              <StyledStepsTitle>{s}</StyledStepsTitle>
            </StyledStepsItem>
          );
        })}
      </StyledSteps>
      <StyledActions>
        <ButtonLink
          variant="brandTalent"
          href="https://getmanfred.typeform.com/to/AEJG1scy"
          target="_blank"
        >
          <FontAwesomeIcon icon={faPlusCircle} />
          <span>{t('how.teamCTA')}</span>
        </ButtonLink>
        <ButtonLink href="#teams" variant="brandCompany">
          <FontAwesomeIcon icon={faBriefcase} />
          <span>{t('how.companyCTA')}</span>
        </ButtonLink>
      </StyledActions>
    </StyledContainer>
  );
};

export default BringYourOwnTeamHow;
